export default __webpack_public_path__ + "static/media/cases3.2acc07f2.jpg";